import { Neuron, NeuronProvider as Provider, SPAConfig } from "@sphtech/neuron";
import { NEURON_EXTENDS } from "@src/app/helpers/getEnvVariables";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

Neuron.default.setConfig({});

export default function NeuronProvider({ children }: Props): ReactNode {
  // Disable Neuron in CUE preview
  if (
    typeof window !== "undefined" &&
    window.location.search.includes("preview_token=")
  ) {
    return children;
  }
  const neuronConfig: SPAConfig = {
    sessionApiUrl: import.meta.env.VITE_NEURON_API_URL as string,
    sessionApiToken: import.meta.env.VITE_NEURON_API_TOKEN as string,
    segmentsApiUrl: import.meta.env.VITE_SEGMENTO_API_URL,
    extends: NEURON_EXTENDS ? [NEURON_EXTENDS] : [],
  };

  return <Provider config={neuronConfig}>{children}</Provider>;
}
